<template>
  <div class="animated fadeIn">
    <router-view @refresh="refresh()"></router-view>
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Server List
        <b-button v-if="only_select != true" class="float-right" variant='success' @click="Download">Download</b-button>
      </template>
      <b-card v-show="so.adv">
        <b-row>
          <b-col>
            <b-form-group label="Usage Mode">
              <b-form-radio-group id="radio-group-2" v-model="so.opt.mode" v-b-tooltip.hover title="Please enter the Usage Mode you want to search for">
                <b-form-radio value="2" @click="so.sv=`mode`">Block Mode</b-form-radio>
                <b-form-radio value="1" @click="so.sv=`mode`">Detect Mode</b-form-radio>
                <b-form-radio value="0" @click="so.sv=`mode`">Off</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Nickname" label-for="ph_code" v-b-tooltip.hover title="Please enter the nickname you want to search for">
              <b-form-input v-model="so.sv" @click="so.sk='nickname';"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            Registration From
            <b-form>
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="4">
            Registration To
            <b-form>
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh" > Search </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="default" @click="so.adv = false"> Cancel </b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col sm="6" v-if="only_select">
          <b-button size="sm" variant="primary" @click="multi_all"> Select All </b-button>
          <b-button size="sm" variant="warning" @click="multi_clear"> Clear </b-button>
        </b-col>
        <b-col sm="6" v-else>
          <span class="text-center" v-b-tooltip.hover title="Specify the number of views on one page">
            Show Count
            <select v-model="so.perPage" @change="refresh">
              <option value="15">Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='nickname';so.skt='nickname';so.adv=false;so.sv=''">Nickname</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='url';so.skt='url';so.adv=false;so.sv=''">URL</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv"  @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table
        :tbody-tr-class="rowClass"
        ref="_wc_agent_list"
        responsive="sm"
        striped hover small fixed
        :items="getItems"
        :fields="fields"
        :current-page="so.currentPage"
        empty-text="not found"
        :per-page="so.perPage"
        v-show="show"
        :sortBy="so.sk"
        @row-clicked="multi_click"
        style="cursor:pointer;"
        >
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template slot="id" slot-scope="row">
          {{only_select != true ? startRow - row.index : ''}}
          <b-form-checkbox :disabled="agent_id == row.item.id" v-if="only_select" v-model="row.item.check" @change="multi_one($event, row)"></b-form-checkbox>
        </template>

        <template slot="is_alive" slot-scope="row">
          <b-badge variant="success" v-if="pong.list.indexOf(row.item.id) > -1">Online</b-badge>
          <!-- <b-badge variant="success" v-else-if="row.item.is_alive">Use</b-badge> -->
          <b-badge v-else variant="secondary">Offline</b-badge>
        </template>
        <template slot="mode" slot-scope="row">
          <!-- <b-badge @click="modal_multi = true" v-if="row.item.manage_id && row.item.manage_id > 0" variant="dark">Multiplexing(?)</b-badge> -->
          <b-badge v-if="row.item.mode == 0" variant="secondary">Off</b-badge>
          <b-badge v-else-if="row.item.mode == 1" variant="warning">Detect</b-badge>
          <b-badge v-else-if="row.item.mode == 2" variant="danger">Block</b-badge>
          <b-badge v-else>None</b-badge>
        </template>
        <template slot="server" slot-scope="row">
          {{row.item.ip_addr}}({{row.item.version}})
        </template>
        <template slot="nickname" slot-scope="row">
          <b-button variant="info" class="pull-right" size="sm" @click="update_nickname = row.item; nickname_modify_modal = true;">Modify</b-button>
          {{row.item.nickname}}
        </template>
        <template slot="domain" slot-scope="row">
          <span @click="modal_domain = true; modal_domain_info = row.item.policy" style="cursor:pointer" v-if="row.item.policy.domains && row.item.policy.domains.length > 1">
            {{row.item.policy.domains.length}}
            <b-button size="sm" variant="success">?</b-button>
          </span>
          <span v-else>default</span>
        </template>
        <template slot="select" slot-scope="row">
          <b-button size="sm" @click="detail(row.item)" >Check</b-button>
          <b-button size="sm" v-if="row.item.is_alive" @click="modal_del = true; del_info = row.item" variant="danger">Remove</b-button>
        </template>
      </b-table>
      <hr>
      <template v-if="!show">
        <b-card>
          <tr>
            <th>No server installed</th>
          </tr>
        </b-card>
      </template>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center":limit="so.perPage" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
      <b-modal title="NickName Modify" v-model="nickname_modify_modal" @ok="nickname_modify()" header-bg-variant="info">
        <p> You can change the nickname of the server. </p>
        <p> Please enter a nickname to change.  </p>
        <p> <b> * Check Server Name </b> </p>
        <p> Origin Server Nickname : {{update_nickname.nickname}}  </p>
        <b-form-input v-model="modify_nickname" placeholder="Please enter a nickname to change."></b-form-input>
      </b-modal>
      <b-modal title="Delete"  class="modal-danger" v-model="modal_del" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
        <p> Agent deletion from the server does not automatically delete it Server recommends deleting first  </p>
        <p> If deleted, the firewall will not be processed.  </p>
        <p> <b> * Check Server Name </b> </p>
        <p> Delete Server Nickname : {{del_info.nickname}}  </p>
        <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
      </b-modal>
      <b-modal title="Usage Domain" v-model="modal_domain" @ok="modal_domain = false" header-bg-variant="info" ok-only>
        <b-table striped hover small fixed class="table-responsive-sm" :items="modal_domain_info.domains" :fields="domain_manage_fields" empty-text="not found">
          <template slot="domain" slot-scope="row">{{row.item.domain}} <b-badge v-if="row.item.temp" variant="danger">Un Saved</b-badge></template>
          <template slot="mode" slot-scope="row">
            <b-badge v-if="row.item.mode == 'Off'" variant="secondary">Off</b-badge>
            <b-badge v-else-if="row.item.mode == 'DetectionOnly'" variant="warning">Detect</b-badge>
            <b-badge v-else-if="row.item.mode == 'On'" variant="danger">Block</b-badge>
            <b-badge v-else>None</b-badge>
          </template>
          <template slot="level" slot-scope="row">{{row.item.level}}</template>
        </b-table>
      </b-modal>
      <b-modal title="Using Multiplexing" v-model="modal_multi" @ok="modal_multi = false" header-bg-variant="warning" ok-only>
        <h5>Managed by a multiplexed firewall policy</h5>
      </b-modal>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
    </div>
</template>


<script>
import { api, signalr } from '@/f1/service'
import DatePicker from 'vue2-datepicker'
// import wordset from './wordset.js';
import moment from 'moment-timezone';
import agent from './service'
import custom  from '@/f1/custom'
import _ from 'lodash'

const default_opt = () => ({
  perPage: 15, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : {}
})

export default {
  name: 'agentList',
  props: ['only_select', 'list_selected', 'agent_id', 'manage_id'],
  watch: {
    list_selected() {
      let id_list = this.list_selected.map(r => r.id)
      this.module_list.forEach(r => {
        r.check = id_list.indexOf(r.id) > -1 ? true : false
      })
      this.selected = id_list
      console.info("list_selected watch updated props data", this.selected.length)
    },
  },
  components : { DatePicker },
  data: () => ({
    // like wsfinder
    modal_multi : false,
    custom,
    selected : [],
    module_list : [],
    // default
    modify_nickname : '',
    nickname_info : '',
    nickname_modify_modal : false,
    update_nickname : {},
    wc_copy_text : "copy",
    strArray : '',
    signalr : signalr.socket(),
    copy_text : "copy",
    show: false,
    so : default_opt(),
    modal_domain : false,
    modal_domain_info : {},
    modal_del : false,
    del_info : {},
    del_nickname : '',
    th : undefined,
    pong : { list : [], cnt : 12 },
  }),
  computed: {
    domain_manage_fields: function () {
      return [
        { key: 'domain', thStyle: 'width: 10%', },
        { key: 'mode', thStyle: 'width: 5%', },
        { key: 'level', thStyle: 'width: 5%', },
      ]
    },
    fields: function () {
      let f = [
        { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
        { key: 'is_alive', label: 'Status' , thStyle: 'width: 10%'},
        { key: 'mode', label: 'Mode', thStyle: 'width: 10%' },
        { key: 'server', label: 'Server' }, // name[host]@ip_addr(version)
        { key: 'nickname', label: 'Nickname' },
        { key: 'domain', label: 'Domain', thStyle: 'width: 15%'},
      ]
      if(this.only_select != true) { f.push({ key: 'select', label: 'More' }) }
      return f;
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    // extra function
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.check) { return 'table-success' }
    },
    multi_click(record, index) {
      try{
        if(this.agent_id == record.id) { return this.$toastr.w("An agent from which to import settings") }
        this.multi_one(!record.check, { item: record }, false)
        console.debug("select", index)
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_one(value, row) {
      try {
        if(this.only_select != true) {
          return console.log("not selecting")
        }

        if(this.agent_id == row.item.id) { return this.$toastr.w("An agent from which to import settings") }
        else if(row.item.manage_id && row.item.manage_id > 0 && row.item.manage_id != this.manage_id) {
          return this.$toastr.w("Managed by multiplexing settings")
        }
        this.$emit("multi_one", { id: row.item.id, nickname: row.item.nickname, is_del: !value });
        if(!value) { this.selected = _.pull(this.selected, row.item.id) }
        else {
          this.selected.push(row.item.id)
        }
        this.selected = _.uniq(this.selected)
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_all() {
      try {
        this.module_list.forEach(r => {
          if(this.agent_id == r.id) { console.log("An agent from which to import settings"); return }
          else if(r.manage_id) { console.log("is already set policy"); return }
          else { r.check = true; this.selected.push(r.id) }
        })

        this.selected = _.uniq(this.selected)
        this.$emit("multi_all", _.uniq(this.module_list.map(r => { if(this.agent_id != r.id) { return { nickname: r.nickname, id: r.id } } })))
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_clear() {
      this.$emit("multi_clear", []); this.module_list.forEach(r => r.check = false)
      this.$refs._wc_agent_list ? this.$refs._wc_agent_list.clearSelected() : ''
      this.selected = []
    },
    // default function
    async nickname_modify() {
      try{
        if(!this.modify_nickname) { return this.$toastr.w("require new nickanme") }
        let body =  Object.assign({}, this.update_nickname, { nickname : this.modify_nickname, policy : undefined })
        let rs = await api.webcastle.WebCastle_Call('agent', 'update', body);
        if(rs.error) { return this.$toastr.e("update failed") }
        this.update_nickname = {};
        this.modify_nickname = '';
        this.$toastr.i("Success.")
        this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''
      } catch(e) { console.log(e) }
    },
    refresh() { console.log('refresh', this.$refs); this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''; if(!this.th) { this.th = setTimeout(() => this.refresh, 3000); }},
    reset() { this.so = default_opt(); this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''},
    hideList(e) { this.show = !e; console.log('agent.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') },
    Download(){ this.$router.replace(`/downloads/`); },
    async ping(){
      if(this.th) { clearTimeout(this.th); }
      if(!(this.module_list && this.module_list.length)) { return }
      (this.module_list || []).forEach(r => agent.Cmd("ping", r.id));
      this.th = setTimeout(this.ping, 3000)
    },
    remove() {
      this.del_nickname = this.del_nickname.trim()
      if(this.del_info.nickname != this.del_nickname) { return this.$toastr.e('Invalid server name entered');  }
      api.webcastle.WebCastle_Call('agent', 'delete', { id : this.del_info.id }).then(() => this.refresh()).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
      this.del_info = {};
      this.del_nickname = '';
      this.modal_del = true;
    },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        // od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        target : 'agent', cmd : 'list'
      }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, target : so.target, cmd : so.cmd, body: { and: [{name : 'is_del', value:false, op: '='}], or: [], sort: [{name : 'id', op : 'desc'}] } }
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: `%${value}%`, op: 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'mode' : search.body.and.push({name: 'mode', value: Number(value) , op: '=' }); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'last_visit_sd' : search.body.and.push({name: 'last_visit', value: moment(value).valueOf(), op: '>=' }); break;
          case 'last_visit_ed' : search.body.and.push({name: 'last_visit', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: `%${value}%`, op: 'like' }); break;
        }
      }
      try{
        let rs = await api.webcastle.WebCastle(search);
        if(rs.error) { return this.$toastr.e("load failed") }
        this.so.totalRows = rs.total;
        this.module_list =  _.map(rs.body, r => { try { r.check = this.selected.indexOf(r.id) > -1; r.policy = JSON.parse(r.policy); } catch (e) { console.log("policy parser issue") } return r });
        this.show = this.so.totalRows > 0 ? true : false;
        this.ping()
        // setTimeout(() => this.ping, 3000);
        this.$emit('count', this.so.totalRows)
        this.$emit('agent_list', this.module_list)

        // 초기 선택을 위함
        if(this.list_selected) {
          let id_list = this.list_selected.map(r => r.id)
          this.module_list.forEach(r => {
            r.check = id_list.indexOf(r.id) > -1 ? true : false
          })
          this.selected = id_list
          console.info("list_selected watch updated props data", this.selected.length)
        }


        return this.module_list;
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
    detail: function(item) {
      this.signalr.off('webcastle');
      this.$router.push(`modules/v2/${item.id}`);
    },
    res(m) { _.indexOf(this.pong.list, m.agent_id) == -1 ? this.pong.list.push(m.agent_id) : '' },
  },
  created: function() {   console.log('modules.list.vue', 'created'); },
  destroyed: function() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    this.signalr.off('webcastle', this.res);
    console.info('modules.list.vue', 'destroyed');
  },
  mounted: function() {
    console.info('modules.list.vue', 'mounted');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    this.signalr.on('webcastle', this.res)
    },
}
</script>
